const pages = [
    {
        path: '/login',
        name: '登录页',
        component: () => import('@/pages/login/login')
    }
]
export default pages